import React from 'react';
import Grid from '@mui/material/Grid2';
import FormLabel from '@mui/material/FormLabel';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

export default function Field({ question, tooltip, children }) {
	return (
		<Grid container alignItems="center" justifyContent="flex-start" spacing={1} sx={{ textAlign: 'left', marginBottom: '1rem', marginTop: '2rem' }}>
			<Grid size={12}>
				<FormLabel style={{ marginBottom: '1rem' }} className="bq-question">
					{question}
					{tooltip && (
						<Tooltip title={<p className="bq-tooltip-text">{tooltip}</p>} placement="top" interactive enterTouchDelay={0} leaveTouchDelay={4000}>
							<IconButton style={{ marginBottom: '5px', marginLeft: '10px', fontSize: '1rem', padding: '0' }}>
								<FontAwesomeIcon icon={faCircleInfo} />
							</IconButton>
						</Tooltip>
					)}
				</FormLabel>
			</Grid>
			{children}
		</Grid>
	);
}
